import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Logo } from '@/components/Logo'
import { loginUrl, registerUrl } from '@/lib/auth'

/* ================================================================== */
/*  Auth handoff.                                                       */
/*                                                                     */
/*  LifeCraft does not host login/signup, the myNext50 webapp does.     */
/*  These routes exist only so every in-site CTA that points at         */
/*  /login or /signup keeps working: they immediately forward the       */
/*  browser to the webapp, carrying a redirect back to this site (and   */
/*  the LifeCrafter role, when present). A brief splash covers the      */
/*  redirect so there's no blank flash.                                 */
/* ================================================================== */

function Handoff({ to, label }: { to: string; label: string }) {
  useEffect(() => {
    window.location.replace(to)
  }, [to])

  return (
    <div className="lc-dark relative flex min-h-screen flex-col items-center justify-center gap-6 bg-night-800 px-6 text-center text-lc-ink">
      <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #191231 0%, #130E22 55%, #170F2A 100%)' }} />
      <div className="relative z-10 flex flex-col items-center gap-6">
        <Logo size={32} />
        <p className="label text-lc-mute">{label}</p>
        <span className="h-6 w-6 animate-spin rounded-full border-2 border-lc-mute/40 border-t-lc-ink" aria-hidden="true" />
        <p className="max-w-xs text-[13px] text-lc-mute">
          If you're not redirected,{' '}
          <a href={to} className="font-semibold text-lc-ink underline decoration-lime decoration-2 underline-offset-4">continue here</a>.
        </p>
      </div>
    </div>
  )
}

export function Login() {
  return <Handoff to={loginUrl()} label="Taking you to sign in…" />
}

export function SignUp() {
  const [params] = useSearchParams()
  const role = params.get('role') ?? undefined
  return <Handoff to={registerUrl(role)} label="Taking you to sign up…" />
}
